export default __webpack_public_path__ + "assets/images/stone-0c069ae993ec9defc698e50917002b2e9.png";